import { ArrowsClockwiseIcon } from '@phosphor-icons/react'
import { TFunction } from 'i18next'

import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'
import { TableColumn } from '@/components/ui/table'
import { DeliveryAccessCode } from '@/pages/packages/drivers-access-code-modal/drivers-access-code-modal.types'

export const getDriversAccessCodeModalColumns = ({
  regeneratingCarrierIds,
  handleRegenerateCode,
  t,
}: {
  regeneratingCarrierIds: Set<number>
  handleRegenerateCode: (carrierId: number) => Promise<void>
  t: TFunction<['packages']>
}): TableColumn<DeliveryAccessCode>[] => [
  {
    id: 'carrierName',
    render: (carrier) => carrier.name,
    title: t('packages:driversAccessCodeModal.columns.carrierName'),
    width: '35%',
  },
  {
    id: 'accessCode',
    render: (carrier) => carrier.code,
    title: t('packages:driversAccessCodeModal.columns.accessCode'),
    width: '25%',
  },
  {
    id: 'regenerate',
    render: (carrier) => {
      const isRegenerating = regeneratingCarrierIds.has(carrier.id)
      return (
        <Button
          use="secondary"
          size="small"
          loading={isRegenerating}
          disabled={isRegenerating}
          onClick={() => handleRegenerateCode(carrier.id)}
        >
          <Icon icon={ArrowsClockwiseIcon} />
          {t('packages:driversAccessCodeModal.regenerate')}
        </Button>
      )
    },
    title: '',
    width: '40%',
  },
]
